import React from 'react';
import { useToast } from '@/contexts/ToastContext';
import { Toast } from './toast';
import { ConfirmationDialog } from './ConfirmationDialog';
import { DeleteErrorDialog } from './DeleteErrorDialog';
import { PermanentDeleteConfirmationDialog } from './PermanentDeleteConfirmationDialog';

export const ToastContainer: React.FC = () => {
  const {
    toasts,
    confirmations,
    deleteErrorDialogs,
    permanentDeleteConfirmations,
    removeToast,
    removeConfirmation,
    removeDeleteErrorDialog,
    removePermanentDeleteConfirmation,
  } = useToast();

  console.log(
    '📦 ToastContainer - Toasts:',
    toasts.length,
    'Confirmations:',
    confirmations.length,
    'DeleteErrorDialogs:',
    deleteErrorDialogs.length,
    'PermanentDeleteConfirmations:',
    permanentDeleteConfirmations.length
  );

  return (
    <>
      {/* Toasts */}
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
          duration={toast.duration}
        />
      ))}

      {/* Confirmation Dialogs */}
      {confirmations.map((confirmation) => (
        <ConfirmationDialog
          key={confirmation.id}
          dialog={confirmation}
          onClose={() => removeConfirmation(confirmation.id)}
        />
      ))}

      {/* Delete Error Dialogs */}
      {deleteErrorDialogs.map((dialog) => (
        <DeleteErrorDialog
          key={dialog.id}
          dialog={dialog}
          onClose={() => removeDeleteErrorDialog(dialog.id)}
        />
      ))}

      {/* Permanent Delete Confirmation Dialogs */}
      {permanentDeleteConfirmations.map((dialog) => (
        <PermanentDeleteConfirmationDialog
          key={dialog.id}
          dialog={dialog}
          onClose={() => removePermanentDeleteConfirmation(dialog.id)}
        />
      ))}
    </>
  );
};
